export default __webpack_public_path__ + "static/media/magazine.70b4a559.png";